import { ICoreContext } from '@msdyn365-commerce/core';
import React, { useMemo, useState } from 'react';
import { IOrderDetailDocument } from '../../../actions/order-details/get-order-details.action';
import DocumentDownloadItem from '../../../utilities/document-download-item';
import { IOrderDetailsResources } from '../order-details.props.autogenerated';

import Dropdown from '../../../components/dropdown';
import { NO_DATA_FALLBACK, ORDER_DETAILS_SDS_DOCUMENT_TYPE_DROPDOWN, ORDER_DETAILS_TDS_DOCUMENT_TYPE } from '../../../configuration';
import { ILocalizationState } from '../../../states/localization-state';
import { dateLocaleFormatter, toLocalDate } from '../../../utilities';

export interface IDataSheetRowProps {
    context: ICoreContext;
    resources: IOrderDetailsResources;
    localizationState: ILocalizationState;
    dataSheetItems: IOrderDetailDocument[];
}

export const DataSheetRow: React.FC<IDataSheetRowProps> = ({ context, resources, localizationState, dataSheetItems }) => {
    const [selectedDocument, setSelectedDocument] = useState<IOrderDetailDocument>(dataSheetItems[0]);

    const languageMap = useMemo(() => {
        const map = new Map<string, IOrderDetailDocument>();
        dataSheetItems.forEach(item => {
            if (item.Language) {
                map.set(item.Language, item);
            }
        });
        return map;
    }, [dataSheetItems]);

    const options = Array.from(languageMap.keys());

    const handleLanguageChange = (selectedLanguage: string) => {
        const document = languageMap.get(selectedLanguage);

        if (document) {
            setSelectedDocument(document);
        }
    };

    if (!selectedDocument) {
        return null;
    }

    return (
        <tr>
            <td>
                <DocumentDownloadItem
                    context={context}
                    resources={resources}
                    documentItem={selectedDocument}
                    isDataSheet={selectedDocument.Type === ORDER_DETAILS_TDS_DOCUMENT_TYPE}
                />
            </td>
            <td>
                {selectedDocument.Date
                    ? dateLocaleFormatter(localizationState).formatDate(toLocalDate(selectedDocument.Date))
                    : NO_DATA_FALLBACK}{' '}
            </td>
            <td>
                {options.length > 1 ? (
                    <Dropdown
                        id={`${ORDER_DETAILS_SDS_DOCUMENT_TYPE_DROPDOWN}-${selectedDocument.Reference}`}
                        title={ORDER_DETAILS_SDS_DOCUMENT_TYPE_DROPDOWN}
                        value={selectedDocument.Language}
                        options={options}
                        placeholder={selectedDocument.Language}
                        onChange={handleLanguageChange}
                    />
                ) : (
                    selectedDocument.Language ?? NO_DATA_FALLBACK
                )}
            </td>
            <td>{selectedDocument.Reference ?? NO_DATA_FALLBACK}</td>
        </tr>
    );
};
